import { Translate } from '@travel/translation';

export const HOTEL_LIST_DEFAULT_SORT = 'provider_recommend';
export const PLAN_DEFAULT_SORT = 'price_low_to_high';

export const HOTEL_LIST_SORT_VALUES = {
  Provider_Recommend: 'Provider_Recommend',
  Price_Low_To_High: 'Price_Low_To_High',
  Price_High_To_Low: 'Price_High_To_Low',
  Guest_Review_Score: 'Guest_Review_Score',
} as const;

export type HOTEL_LIST_SORT_TYPE =
  (typeof HOTEL_LIST_SORT_VALUES)[keyof typeof HOTEL_LIST_SORT_VALUES];

export const PLAN_DETAIL_SORT_VALUES = {
  Price_Low_To_High: 'Price_Low_To_High',
  Price_High_To_Low: 'Price_High_To_Low',
  Room_Size: 'Room_Size',
} as const;

export type PLAN_DETAIL_SORT_TYPE =
  (typeof PLAN_DETAIL_SORT_VALUES)[keyof typeof PLAN_DETAIL_SORT_VALUES];

export const PLAN_LIST_SORT_VALUES = {
  ...PLAN_DETAIL_SORT_VALUES,
  Rate_Plan_Recommend: 'Rate_Plan_Recommend',
} as const;

export type PLAN_LIST_SORT_TYPE =
  (typeof PLAN_LIST_SORT_VALUES)[keyof typeof PLAN_LIST_SORT_VALUES];

export type SortKeyMapping<T> = {
  [key: string]: {
    name: React.ReactNode;
    value: T;
  };
};

export const HOTEL_LIST_SORT: SortKeyMapping<HOTEL_LIST_SORT_TYPE> = {
  provider_recommend: {
    name: <Translate id="DP_Enumeration.Hotel_Sort.Provider.Recommended" />,
    value: 'Provider_Recommend',
  },
  price_low_to_high: {
    name: <Translate id="DP_Enumeration.Hotel_Sort.Price.Low_High" />,
    value: 'Price_Low_To_High',
  },
  price_high_to_low: {
    name: <Translate id="DP_Enumeration.Hotel_Sort.Price.High_Low" />,
    value: 'Price_High_To_Low',
  },
  guest_review_score: {
    name: <Translate id="DP_Enumeration.Hotel_Sort.Review_Score.High_Low" />,
    value: 'Guest_Review_Score',
  },
};

export const PLAN_DETAIL_SORT: SortKeyMapping<PLAN_DETAIL_SORT_TYPE> = {
  price_low_to_high: {
    name: <Translate id="DP_Enumeration.Plan_Sort.Price.Low_High" />,
    value: 'Price_Low_To_High',
  },
  price_high_to_low: {
    name: <Translate id="DP_Enumeration.Plan_Sort.Price.High_Low" />,
    value: 'Price_High_To_Low',
  },
  room_size: {
    name: <Translate id="DP_Enumeration.Hotel_Sort.Size_of_Room" />,
    value: 'Room_Size',
  },
};

export const PLAN_LIST_SORT: SortKeyMapping<PLAN_LIST_SORT_TYPE> = {
  rate_plan_recommend: {
    name: <Translate id="DP_Enumeration.Plan_Sort.Plan.Recommended" />,
    value: 'Rate_Plan_Recommend',
  },
  ...PLAN_DETAIL_SORT,
};

export enum FilterGroupId {
  PRICE_FILTER = 'priceFilter',
}
